import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { Protegido } from './componentes/Protegido';
import { Layout } from './componentes/Layout';
import { Login } from './paginas/Login';

// Páginas del flujo principal (carga inmediata).
import { Dashboard } from './paginas/Dashboard';
import { BuscarExpediente } from './paginas/BuscarExpediente';
import { MisDocumentos } from './paginas/MisDocumentos';
import { AdjuntarDocumentos } from './paginas/AdjuntarDocumentos';

// El resto se carga bajo demanda (divide el bundle → arranque más liviano).
const DetalleExpediente = lazy(() => import('./paginas/DetalleExpediente').then((m) => ({ default: m.DetalleExpediente })));
const CrearExpediente = lazy(() => import('./paginas/CrearExpediente').then((m) => ({ default: m.CrearExpediente })));
const ExpedientesUsuario = lazy(() => import('./paginas/ExpedientesUsuario').then((m) => ({ default: m.ExpedientesUsuario })));
const ExpedientesOficina = lazy(() => import('./paginas/ExpedientesOficina').then((m) => ({ default: m.ExpedientesOficina })));
const EntregaTurno = lazy(() => import('./paginas/EntregaTurno').then((m) => ({ default: m.EntregaTurno })));
const Reportes = lazy(() => import('./paginas/Reportes').then((m) => ({ default: m.Reportes })));
const ReporteTurnos = lazy(() => import('./paginas/ReporteTurnos').then((m) => ({ default: m.ReporteTurnos })));
const CambioOficina = lazy(() => import('./paginas/CambioOficina').then((m) => ({ default: m.CambioOficina })));
const GestionMasiva = lazy(() => import('./paginas/GestionMasiva').then((m) => ({ default: m.GestionMasiva })));
const Administracion = lazy(() => import('./paginas/Administracion').then((m) => ({ default: m.Administracion })));

function Cargando() {
  return <div className="cargando" style={{ padding: 40, textAlign: 'center', color: 'var(--cji-green-primary)' }}>Cargando…</div>;
}

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Suspense fallback={<Cargando />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <Protegido>
                  <Layout />
                </Protegido>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/mis-documentos" element={<MisDocumentos />} />
              <Route path="/adjuntar" element={<AdjuntarDocumentos />} />
              <Route path="/turnos" element={<ReporteTurnos />} />
              <Route path="/buscar" element={<BuscarExpediente />} />
              <Route path="/expediente/:id" element={<DetalleExpediente />} />
              <Route path="/expedientes-usuario" element={<ExpedientesUsuario />} />
              <Route path="/expedientes-oficina" element={<ExpedientesOficina />} />
              <Route path="/entrega-turno" element={<EntregaTurno />} />
              <Route path="/reportes" element={<Reportes />} />
              <Route path="/cambio-oficina" element={<CambioOficina />} />
              <Route path="/crear" element={<CrearExpediente />} />
              <Route path="/gestion-masiva" element={<GestionMasiva />} />
              <Route path="/administracion" element={<Protegido requiere="admin"><Administracion /></Protegido>} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </AuthProvider>
  );
}
